















































import {Vue, Component, Watch} from 'vue-property-decorator'
import moment from "moment";
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";
import VisitedStores from "@/views/Izvestaji/Merchandisers/DnevnaAktivnostMerchandisera/VisitedStores.vue";
import Totals from "@/views/Izvestaji/Merchandisers/DnevnaAktivnostMerchandisera/Totals.vue";
import Map from "@/views/Izvestaji/Merchandisers/DnevnaAktivnostMerchandisera/Map.vue";
import TakenImages from "@/views/Izvestaji/Merchandisers/DnevnaAktivnostMerchandisera/TakenImages.vue";

@Component({
  components: {
    'visited-stores': VisitedStores,
    'totals': Totals,
    'merch-map': Map,
    'taken-images': TakenImages
  }
})
export default class DnevnaAktivnostMerchandisera extends mixins(ComponentBaseMixin) {
  selectedDate: any = '';
  params = {
    userId: null,
    date: null
  };

  merchandisers = [];
  storeID = '';

  async created() {
    this.selectedDate = new Date();
    this.axios.get('api/GetUsersByRole/merchandiser').then(res => {
      if (res.data.length > 0) {
        this.params.userId = res.data[0].id;
      }
      this.merchandisers = res.data;
    }).catch(err => {
      this.showError('neuspesnoUcitavanjePodataka');
    })
  }

  @Watch('selectedDate') onDateChange(val) {
    this.params = {
      userId: this.params.userId,
      date: moment(val).format('YYYY-MM-DD')
    };
  }

  selectUser(id) {
    this.params.userId = id;
  }

  onVisitedStoreRowClick(id) {
    this.storeID = id;
  }


}
